var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useForm } from 'react-final-form';
import { disabledOption, formKeyToFilterKey, OtherFiltersMapping } from '../utils';
import MultiSelectFilter from './MultiSelectFilter';
var RequirementFilters = function (props) {
    var form = useForm();
    var options = React.useMemo(function () {
        return OtherFiltersMapping.map(function (_a) {
            var _b, _c, _d, _e;
            var key = _a.key, title = _a.title, order = _a.order;
            var data = (_b = props === null || props === void 0 ? void 0 : props.aggregationData) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.key === (formKeyToFilterKey === null || formKeyToFilterKey === void 0 ? void 0 : formKeyToFilterKey[key]); });
            return {
                label: title,
                value: key,
                count: (_e = (_d = (_c = data === null || data === void 0 ? void 0 : data.options) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.count) !== null && _e !== void 0 ? _e : 0,
                key: key,
                order: order
            };
        }).sort(function (a, b) { return a.order - b.order; });
    }, [props.aggregationData]);
    var values = React.useMemo(function () {
        var selectedValues = [];
        OtherFiltersMapping.forEach(function (_a) {
            var _b, _c;
            var key = _a.key, rest = __rest(_a, ["key"]);
            if ((_c = (_b = form === null || form === void 0 ? void 0 : form.getState()) === null || _b === void 0 ? void 0 : _b.values) === null || _c === void 0 ? void 0 : _c[key]) {
                selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.push(__assign(__assign({ key: key }, rest), { value: key, label: rest === null || rest === void 0 ? void 0 : rest.title }));
            }
        });
        return selectedValues;
    }, [props.aggregationData]);
    var handleApply = function (values) {
        var _a, _b;
        var selectedKeys = (_a = values === null || values === void 0 ? void 0 : values.map(function (v) { return v === null || v === void 0 ? void 0 : v.key; })) !== null && _a !== void 0 ? _a : [];
        (_b = props === null || props === void 0 ? void 0 : props.onApply) === null || _b === void 0 ? void 0 : _b.call(props, options.map(function (o) {
            if (selectedKeys.includes(o.key)) {
                return __assign(__assign({}, o), { value: 'true' });
            }
            else {
                return __assign(__assign({}, o), { value: null });
            }
        }));
    };
    return (React.createElement(MultiSelectFilter, { label: "Requirement Filters", options: options, getOptionDisabled: disabledOption, onApply: handleApply, values: values }));
};
export default RequirementFilters;
//# sourceMappingURL=RequirementFilters.js.map